/**
 * Page Gestion des Tables
 * 
 * Cette page permet de gérer les tables pour les restaurants :
 * - Affichage des tables disponibles/occupées
 * - Gestion des réservations
 * - Attribution des commandes aux tables
 * - Statut des tables en temps réel
 * - Plan de salle interactif
 * 
 * @component
 * @returns {JSX.Element} Composant Tables
 */

import React, { useEffect } from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { aside as frAside } from '../../../../locales/fr/aside';
import { aside as arAside } from '../../../../locales/ar/aside';
import { aside as esAside } from '../../../../locales/es/aside';
import useMyAppStore from '../../../../stores/myAppStore';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const Tables = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { setPageTitle } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.tables || 'Gestion des Tables');
  }, [lang, t.routes.tables, setPageTitle]);

  return (
    <div className="container mx-auto">
      <h1 className="text-2xl font-bold mb-4">Gestion des Tables</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="text-center py-12">
          <div className="text-6xl mb-4">🪑</div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            Plan de Salle
          </h2>
          <p className="text-gray-500">
            Page en cours de développement
          </p>
          <div className="mt-6 p-4 bg-orange-50 rounded-lg">
            <h3 className="font-medium text-orange-800 mb-2">Fonctionnalités prévues :</h3>
            <ul className="text-sm text-orange-700 space-y-1">
              <li>• Plan de salle interactif avec disposition des tables</li>
              <li>• Statut en temps réel (libre, occupée, réservée)</li>
              <li>• Gestion des réservations par table</li>
              <li>• Attribution des commandes aux tables</li>
              <li>• Calcul du temps d'occupation</li>
              <li>• Gestion de la capacité et du placement</li>
              <li>• Notifications de libération de table</li>
              <li>• Historique des utilisations par table</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tables; 